class LoginSsoPage {
    init() {
        this.view = new Vue({
          el: '#has-account',
          data() {
            let vue = this;
            return {
              greeting: "Hello!",
              username: "",
              recaptureReturned: null,
              returnUrl: returnUrl,
              ssoFailure: null
            }
          },
          methods: {
            init: function () {
                if (window.sessionStorage && sessionStorage.username) {
                    this.username = sessionStorage.username;
                }
            },
            recoverUsername: function () {
                if ( window.sessionStorage ) {
                    sessionStorage.username = this.username
                }
            },
            onProtectedSubmit: function(e) {
                let that = this
                e.preventDefault();
                grecaptcha.ready(function() {
                  grecaptcha.execute('6Lc0g0AnAAAAAGHibVMDuzlUt388OCEkLpv8wM76', {action: 'submit'}).then(function(token) {
                      that.recaptureReturned = token
                      if( that.recaptureReturned ){
                          that.$nextTick( () => $("#login_form").submit() );
                      }
                  });
                });
            }
          },
          mounted() {
              let tdPrefs = localStorage.getItem('dateTimePreferences')
              const urlParams = new URLSearchParams(window.location.search);
              let r = urlParams.get("r");
              if( !this.returnUrl && r ){
                  this.returnUrl = r;
              }

              let f = urlParams.get("failed");
              if( f == 1 ){
                  let message = urlParams.get("message");
                  if( message ){
                      this.ssoFailure = {
                          "errorMessage": message
                      };
                  }
              }

              if (tdPrefs && tdPrefs.length) {
                tdPrefs = JSON.parse(tdPrefs)
              }
              var d = new Date();
              var n = tdPrefs && tdPrefs.timezone ? d.getHours() + (parseInt(tdPrefs.timezone.offset, 10)) : d.getHours();
              switch(n) {
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                  this.greeting = "Good morning!";
                  break;
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                  this.greeting = "Good afternoon!";
                  break;
                default:
                  this.greeting = "Good evening!";
              }
            }
        })

        this.view.init();
    }
}
